// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fP0tvrydHAK9o8g2KZQX{border:1px solid var(--border-neutral-default);border-radius:12px;flex-direction:column;padding:20px;display:flex}.W5etYZuTS8QqRbpWRXXO{justify-content:space-between;display:flex}.Em0kJwnwr7gytKd7hklK{flex-direction:column;gap:4px;display:flex}.mSqPWEKmyI8RhJLBa1Cb{gap:8px;display:flex}.ofzip3zMcstD0hhCoo6v{height:32px}.Ypk9Gg7U3jgTgxBFUPcq{align-items:center;gap:4px;display:flex}.BqpX6G4yEVk9KAUukUCh:hover{cursor:pointer;border:1px solid var(--border-neutral-primary);background:var(--background-primary-transparent)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `fP0tvrydHAK9o8g2KZQX`,
	"info": `W5etYZuTS8QqRbpWRXXO`,
	"leftContent": `Em0kJwnwr7gytKd7hklK`,
	"rightContent": `mSqPWEKmyI8RhJLBa1Cb`,
	"button": `ofzip3zMcstD0hhCoo6v`,
	"useCaseDefault": `Ypk9Gg7U3jgTgxBFUPcq`,
	"clickable": `BqpX6G4yEVk9KAUukUCh`
};
export default ___CSS_LOADER_EXPORT___;
